import React from "react";
import { RoyalTeam, RoyalTeamContent, RoyalTeamTitle } from "./teamStyle";

const Team = () => {
  return (
    <RoyalTeam>
      <RoyalTeamTitle>the royal team</RoyalTeamTitle>
      <RoyalTeamContent>
        
      </RoyalTeamContent>
    </RoyalTeam>
  );
};

export default Team;
